ItemorderModalController.$inject= ['ItemorderService', 'ItemService', 'ItemorderConfig'];
export default function ItemorderModalController(ItemorderService, ItemService, ItemorderConfig) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.catalogid = ItemorderConfig.catalogid;
        ctrl.desks = ItemorderConfig.desks;
    };
    
    ctrl.selected = {};

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.docid = changes.resolve.currentValue.params.docid;
            ctrl.r = changes.resolve.currentValue.params.opacrecord;
            ctrl.load();
        }
    }

    ctrl.load = function() {
        if (!ctrl.r) {
            var qs  = {
                cat: 'document',
                docid: ctrl.docid.replace(/\\/g, "\\\\"),
                syntax: 'opac'
            };
            ItemService.get(qs).$promise.then(function(response) {
                if (response.success && response.data.records) {
                    ctrl.r = response.data.records[0].recordData;
                } else {
                    ctrl.r = '(error)';
                }
            });
        }
    };

    ctrl.itemorder = function() {
        var qs = {
            databasename: 'ucat', // FIXME! Hardcoded!
            syntax: 'rusmarc'
        };
        qs.docid = ctrl.docid.replace(/\\/g, '\\\\');
        qs.circdesk = ctrl.selected.desk.nuc + '/' + ctrl.selected.desk.loc + '/' + ctrl.selected.desk.desk;

        ctrl.isProcess = true;

        ItemorderService.get(qs).$promise.then(function(response) {
            if (response["status"] === 1) {
                ctrl.response = response;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.content);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };
}
